var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-collapse", _vm._l(_vm.collapses, function (item) {
    return _c("a-collapse-panel", {
      key: item.key,
      attrs: {
        header: _vm.$t(item.title)
      }
    }, [_c("contactWayFormModel", {
      attrs: {
        type: _vm.type,
        language: item.key,
        item: _vm.datas
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };